module.exports = __webpack_public_path__ + "static/media/Worlds - Hexagon.94076f20.png";